<template>
	<v-card class="fill-height">
		<v-card-text>
			<v-layout wrap>
				<v-flex xs12>
					<v-autocomplete
						label="Categories"
						v-model="selected_categories"
						name="categories"
						cache-items
						:loading="categoriesLoading"
						:search-input.sync="search"
						:items="categories"
						placeholder="Select Categories"
						item-text="name"
						item-value="id"
						height="35"
						browser-autocomplete="disabled"
						multiple
						hide-details
						small-chips
						dense
						flat
						outlined
						clearable
					></v-autocomplete>
				</v-flex>

				<v-flex xs12>
					<div class="selected-documents" @click="selectDocuments">
						<div class="selected-documents__selections">
							<v-chip
								v-for="attachment in attachments"
								:key="attachment.id"
								close
								@input="removeAttachment(attachment)"
							>
								<span class="v-chip__text">
									{{ attachment.name }}
								</span>
							</v-chip>
						</div>

						<div class="v-icon">
							<fa-icon :icon="['far', 'upload']" size="xs" />
						</div>
					</div>
					<div class="selected-documents__accepted">
						Accepted File Extensions: .doc, .docx, .dwg, .jpg,
						.jpeg, .pdf, .png, .stp
					</div>
					<input
						type="file"
						id="attachments"
						ref="document"
						multiple="multiple"
						accept=".jpg, .jpeg, .png, .pdf, .doc, .docx, .stp, .dwg"
						@change="uploadFieldChange"
						class="selected-documents__input"
					/>
				</v-flex>

				<v-flex xs12>
					<v-autocomplete
						v-model="permission_groups"
						item-text="name"
						item-value="id"
						:items="permissionGroups"
						label="Permission Groups"
						placeholder="Select Permission Groups"
						height="35"
						multiple
						hide-details
						small-chips
						dense
						flat
						outlined
						clearable
					></v-autocomplete>
				</v-flex>
			</v-layout>
		</v-card-text>

		<v-card-actions class="pa-3">
			<v-spacer></v-spacer>

			<v-btn @click="$router.back()">Cancel</v-btn>
			<v-btn @click="upload_callback" :disabled="loading">
				<fa-icon :icon="['fas', 'cog']" spin size="lg" v-if="loading" />
				<span v-else>Upload</span>
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { log } from "util";

export default {
	data() {
		return {
			search: "",
			categories: [],
			attachments: [],
			// Each file will need to be sent as FormData element
			data: new FormData(),
			selected_categories: [],
			permission_groups: [],
			loading: false,
			categoriesLoading: false,
			percentCompleted: 0
		};
	},
	computed: {
		...mapGetters(["dark", "user"]),
		...mapGetters("document_center", [
			"selectedCategory",
			"permissionGroups"
		])
	},
	methods: {
		...mapActions("document_center", ["uploadDocument"]),

		...mapActions("document_center", {
			GET_CATEGORIES: "getCategories"
		}),

		selectDocuments() {
			this.$refs.document.click();
		},

		category_callback() {
			// console.log("category callback");
		},

		// This function will be called every time you add a file
		uploadFieldChange(e) {
			var files = e.target.files || e.dataTransfer.files;

			if (!files.length) {
				return;
			}

			for (var i = files.length - 1; i >= 0; i--) {
				let file = files[i];

				if (
					_.find(this.attachments, {
						lastModified: file.lastModified,
						name: file.name,
						size: file.size,
						type: file.type
					})
				) {
					continue;
				}

				this.attachments.push(files[i]);
			}

			// Reset the form to avoid copying these files multiple times into this.attachments
			document.getElementById("attachments").value = [];
		},

		getAttachmentSize() {
			this.upload_size = 0; // Reset to beginningƒ
			this.attachments.map(item => {
				this.upload_size += parseInt(item.size);
			});

			this.upload_size = Number(this.upload_size.toFixed(1));
			this.$forceUpdate();
		},

		prepareFields() {
			if (this.attachments.length > 0) {
				_.forEach(this.attachments, (item, key) => {
					this.data.append("files[]", item);
				});

				_.forEach(this.selected_categories, (item, key) => {
					this.data.append("categories[]", item);
				});

				_.forEach(this.permission_groups, (item, key) => {
					this.data.append("permission_groups[]", item);
				});
			}
		},

		removeAttachment(attachment) {
			this.attachments.splice(this.attachments.indexOf(attachment), 1);
			this.getAttachmentSize();
		},

		upload_callback() {
			this.prepareFields();

			this.loading = true;

			// let payload = {
			//     file_data : this.data,
			//     categories: this.selected_categories
			// };
			//
			// console.log(payload);
			this.uploadDocument(this.data)
				.then(res => {})
				.catch(err => {})
				.finally(() => {
					this.loading = false;
					this.attachments = [];
					this.selected_categories = [];
					this.permission_groups = [];
					this.data = new FormData();
				});
		},

		getCategories: _.debounce(function() {
			this.categoriesLoading = true;

			let payload = { admin: true };

			if (this.search) {
				payload.search = this.search;
			} else {
				payload.topLevel = true;
			}

			this.GET_CATEGORIES(payload)
				.then(({ data }) => {
					const categories = this.getFullCategoryNames([
						this.selectedCategory,
						...data
					]);

					let count = 0;
					while (count < categories.length) {
						this.$set(
							this,
							"categories",
							_.slice(categories, count, (count += 100))
						);
					}
				})
				.finally(() => {
					this.categoriesLoading = false;
				});
		}, 100),

		getFullCategoryNames(categories) {
			return (categories || []).map(category => {
				const names = [category.name];

				let parent = category.parent;
				while (parent) {
					names.unshift(parent.name);
					parent = parent.parent;
				}

				return {
					...category,
					name: names.join(" -> ")
				};
			});
		}
	},

	created() {
		this.$set(
			this,
			"categories",
			this.getFullCategoryNames([this.selectedCategory])
		);

		this.$set(this, "selected_categories", [this.selectedCategory.id]);
	},

	watch: {
		search(value, oldValue) {
			if (value !== oldValue && value !== null && value.length >= 3) {
				this.getCategories();
			}
		}
	}
};
</script>
